import { render, staticRenderFns } from "./carousel.vue?vue&type=template&id=661349b2&scoped=true&"
var script = {}
import style0 from "./carousel.vue?vue&type=style&index=0&id=661349b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661349b2",
  null
  
)

export default component.exports